import React, { useCallback } from 'react'
import { ICellRendererParams } from 'ag-grid-community'
import { CellRendererRoot } from '.'
import { Checkbox } from '../../../../../components/inputs/Checkbox'
import { Row } from '../../../../../containers/BulkSheetView/model'

type CheckboxCellRendererProps = ICellRendererParams<Row, boolean> & {
  updateSelectedUuid: (uuid: string, selected: boolean) => void
}

export const CheckboxCellRenderer = ({
  value,
  data,
  updateSelectedUuid,
}: CheckboxCellRendererProps) => {
  const onChange = useCallback(
    (_, value: boolean) => {
      if (!data) return
      updateSelectedUuid(data.uuid, value)
    },
    [data, updateSelectedUuid]
  )
  return (
    <CellRendererRoot>
      <Checkbox checked={value} onChange={onChange} />
    </CellRendererRoot>
  )
}
